import { useEffect } from "react";

const insertBeforeNumber = (str, valueToInsert) => {
  return str.replace(/<sup>(.*?)<\/sup>/, (match, content) => {
    const index = content.search(/\d/);

    if (index === -1) {
      return `<sup>${content.replace(/,\s*$/, "")},${valueToInsert}</sup>`;
    }

    const before = content.slice(0, index).replace(/,\s*$/, "");
    const after = content.slice(index);

    return `<sup>${before},${valueToInsert}${after}</sup>`;
  });
};

const removeTokenInsideSup = (text, token) => {
  const match = text.match(/<sup>(.*?)<\/sup>/);

  if (!match) return text;

  const insideSup = match[1];
  const updatedSup = insideSup
    .split(",")
    .filter((item) => item !== token)
    .join(",");

  return text.replace(match[1], updatedSup);
};

export const useEditorClaimReferencesSync = ({
  layerCompData,
  setLayerCompData,
  claimReferencesFootnotes,
  scrollClaimReferencesFootnotes,
  claimsArray,
  refClaimReferencesFootnotes,
  refScrollClaimReferencesFootnotes,
}) => {
  useEffect(() => {
    let tempLayerCompData = [...layerCompData];
    let referenceCombinedText = "<b/>Reference: </b>";
    if (claimReferencesFootnotes.references) {
      let totalReferences = 0;
      let referenceMp = new Set();
      claimReferencesFootnotes.references.forEach((reference) => {
        let refText = reference.referenceArray
          .map((item) => {
            if (!referenceMp.has(item.documentName)) {
              totalReferences++;
              referenceMp.add(item.documentName);
              return `${totalReferences}. ${item.documentName}`;
            }
          })
          .join(" ");
        referenceCombinedText += `${refText} `;
      });
      tempLayerCompData.forEach((component) => {
        if (component.reference && referenceCombinedText) {
          component.froalaText = referenceCombinedText;
        }
      });
    }

    let combinedFoonotesText = "<b>Footnotes: </b>";
    if (claimReferencesFootnotes.footnotes) {
      let footnotesMp = new Set();
      const result = [];
      for (let i = claimReferencesFootnotes.footnotes.length - 1; i >= 0; i--) {
        result.unshift(claimReferencesFootnotes.footnotes[i]);
      }
      result.forEach((footnote) => {
        if (!footnotesMp.has(footnote.footnotesText)) {
          footnotesMp.add(footnote.footnotesText);
          combinedFoonotesText += `${footnote.footnotesText} `;
        }
      });

      tempLayerCompData.forEach((component) => {
        if (component.footnotes && combinedFoonotesText) {
          component.froalaText = combinedFoonotesText;
        }
      });
    }

    let combinedAbbreviationText = "<b>Abbreviation: </b>";
    if (claimReferencesFootnotes.abbreviation) {
      let abbreviationMp = new Set();
      const result = [];
      for (
        let i = claimReferencesFootnotes.abbreviation.length - 1;
        i >= 0;
        i--
      ) {
        result.unshift(claimReferencesFootnotes.abbreviation[i]);
      }
      result.forEach((abbreviation) => {
        if (!abbreviationMp.has(abbreviation.abbreviationText)) {
          abbreviationMp.add(abbreviation.abbreviationText);
          combinedAbbreviationText += `${abbreviation.abbreviationText}; `;
        }
      });

      tempLayerCompData.forEach((component) => {
        if (component.abbreviation && combinedAbbreviationText) {
          component.froalaText = combinedAbbreviationText;
        }
      });
    }
    tempLayerCompData.forEach((component) => {
      if (component.rcClaimIds?.length > 0) {
        component.rcClaimIds.forEach((rcClaimId) => {
          if (claimsArray.includes(rcClaimId)) {
            const tempComponent = tempLayerCompData.find(
              (c) => c.claimId === rcClaimId,
            );
            const insertText = `${tempComponent?.matchTextSymbol},` || "";
            if (!component.rcSybmols) {
              component.rcSybmols = [];
            }
            if (
              component.rcSybmols &&
              !component.rcSybmols.includes(tempComponent?.matchTextSymbol)
            ) {
              component.froalaText = insertBeforeNumber(
                component.froalaText,
                insertText,
              );
              component.rcSybmols.push(tempComponent?.matchTextSymbol);
            }
          } else {
            const tempComponent = tempLayerCompData.find(
              (c) => c.claimId === rcClaimId,
            );
            if (
              tempComponent &&
              component.rcSybmols &&
              component.rcSybmols.includes(tempComponent?.matchTextSymbol)
            ) {
              component.rcSybmols.splice(
                component.rcSybmols.indexOf(tempComponent?.matchTextSymbol),
                1,
              );
              component.froalaText = removeTokenInsideSup(
                component.froalaText,
                tempComponent?.matchTextSymbol,
              );
            }
          }
        });
      }
    });
    if (
      claimReferencesFootnotes.footnotes ||
      claimReferencesFootnotes.references ||
      claimReferencesFootnotes.abbreviation
    ) {
      setLayerCompData(tempLayerCompData);
    }
    refClaimReferencesFootnotes.current = claimReferencesFootnotes;
  }, [claimReferencesFootnotes]);

  useEffect(() => {
    let tempLayerCompData = [...layerCompData];
    let referenceCombinedText = "<b/>Reference: </b>";
    if (scrollClaimReferencesFootnotes.references) {
      let referenceMp = new Set();
      let totalReferences = 0;
      scrollClaimReferencesFootnotes.references.forEach((reference) => {
        let refText = reference.referenceArray
          .map((item) => {
            if (!referenceMp.has(item.documentName)) {
              totalReferences++;
              referenceMp.add(item.documentName);
              return `${totalReferences}. ${item.documentName}`;
            }
          })
          .join(" ");
        referenceCombinedText += `${refText} `;
      });
      tempLayerCompData.forEach((component) => {
        const scrollComponents = component?.scrollbarComponents;
        if (!Array.isArray(scrollComponents)) return;
        scrollComponents.forEach((scrollComponent) => {
          if (scrollComponent.reference && referenceCombinedText) {
            scrollComponent.froalaText = referenceCombinedText;
          }
        });
      });
    }

    let combinedFootnotesText = "<b>Footnotes: </b>";
    if (scrollClaimReferencesFootnotes.footnotes) {
      let footnotesMp = new Set();
      const result = [];
      for (
        let i = scrollClaimReferencesFootnotes.footnotes.length - 1;
        i >= 0;
        i--
      ) {
        result.unshift(scrollClaimReferencesFootnotes.footnotes[i]);
      }
      result.forEach((footnote) => {
        if (!footnotesMp.has(footnote.footnotesText)) {
          footnotesMp.add(footnote.footnotesText);
          combinedFootnotesText += `${footnote.footnotesText} `;
        }
      });

      tempLayerCompData.forEach((component) => {
        const scrollComponents = component?.scrollbarComponents;
        if (!Array.isArray(scrollComponents)) return;
        scrollComponents.forEach((scrollComponent) => {
          if (scrollComponent.footnotes && combinedFootnotesText) {
            scrollComponent.froalaText = combinedFootnotesText;
          }
        });
      });
    }

    let combinedAbbreviationText = "<b>Abbreviation: </b>";
    if (scrollClaimReferencesFootnotes.abbreviation) {
      let abbreviationMp = new Set();
      const result = [];
      for (
        let i = scrollClaimReferencesFootnotes.abbreviation.length - 1;
        i >= 0;
        i--
      ) {
        result.unshift(scrollClaimReferencesFootnotes.abbreviation[i]);
      }
      result.forEach((abbreviation) => {
        if (!abbreviationMp.has(abbreviation.abbreviationText)) {
          abbreviationMp.add(abbreviation.abbreviationText);
          combinedAbbreviationText += `${abbreviation.abbreviationText}; `;
        }
      });

      tempLayerCompData.forEach((component) => {
        const scrollComponents = component?.scrollbarComponents;
        if (!Array.isArray(scrollComponents)) return;
        scrollComponents.forEach((scrollComponent) => {
          if (scrollComponent.abbreviation && combinedAbbreviationText) {
            scrollComponent.froalaText = combinedAbbreviationText;
          }
        });
      });
    }
    tempLayerCompData.forEach((component) => {
      const scrollComponents = component?.scrollbarComponents;
      if (!Array.isArray(scrollComponents)) return;
      scrollComponents.forEach((scrollComponent) => {
        if (scrollComponent.rcClaimIds?.length > 0) {
          scrollComponent.rcClaimIds.forEach((rcClaimId) => {
            if (claimsArray.includes(rcClaimId)) {
              const tempComponent = scrollComponents.find(
                (c) => c.claimId === rcClaimId,
              );
              const insertText = `${tempComponent?.matchTextSymbol},` || "";
              if (!scrollComponent.rcSybmols) {
                scrollComponent.rcSybmols = [];
              }
              if (
                scrollComponent.rcSybmols &&
                !scrollComponent.rcSybmols.includes(
                  tempComponent?.matchTextSymbol,
                )
              ) {
                scrollComponent.froalaText = insertBeforeNumber(
                  scrollComponent.froalaText,
                  insertText,
                );
                scrollComponent.rcSybmols.push(tempComponent?.matchTextSymbol);
              }
            } else {
              const tempComponent = scrollComponents.find(
                (c) => c.claimId === rcClaimId,
              );
              if (
                tempComponent &&
                scrollComponent.rcSybmols &&
                scrollComponent.rcSybmols.includes(
                  tempComponent?.matchTextSymbol,
                )
              ) {
                scrollComponent.rcSybmols.splice(
                  scrollComponent.rcSybmols.indexOf(
                    tempComponent?.matchTextSymbol,
                  ),
                  1,
                );
                scrollComponent.froalaText = removeTokenInsideSup(
                  scrollComponent.froalaText,
                  tempComponent?.matchTextSymbol,
                );
              }
            }
          });
        }
      });
    });
    if (
      scrollClaimReferencesFootnotes.foonotes ||
      scrollClaimReferencesFootnotes.references ||
      scrollClaimReferencesFootnotes.abbreviation
    ) {
      setLayerCompData(tempLayerCompData);
    }
    refScrollClaimReferencesFootnotes.current = scrollClaimReferencesFootnotes;
  }, [scrollClaimReferencesFootnotes]);
};
